export enum EstablishmentMode {
  Live = 'live',
  Test = 'test',
}